import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdministrationComponent} from './administration.component';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import {LicenseSettingsModule} from './license-settings/license-settings.module';
import {AnalyticsSettingsModule} from './analytics-settings/analytics-settings.module';
import {SecuritySettingsModule} from './security-settings/security-settings.module';
import {RemoteManagerModule} from './remote-manager/remote-manager.module';
import {RadiusAuthenticationModule} from './radius-authentication/radius-authentication.module';
import {LdapAuthenticationModule} from './ldap-authentication/ldap-authentication.module';
import {AzureAuthenticationModule} from './azure-authentication/azure-authentication.module';
import {TrustedCertificatesModule} from './trusted-certificates/trusted-certificates.module';
import {ConfiguratorCredentialsModule} from './configurator-credentials/configurator-credentials.module';
import {CredentialsModule} from './credentials/credentials.module';
import {OperatorsSettingsModule} from './operators-settings/operators-settings.module';
import {ConfiguratorCertificateModule} from './configurator-certificate/configurator-certificate.module';
import {SecurityPoliciesModule} from './security-policies/security-policies.module';

@NgModule({
  declarations: [
    AdministrationComponent
  ],
  imports: [
    CommonModule,
    ArmSideNavModule,
    LicenseSettingsModule,
    SecuritySettingsModule,
    RemoteManagerModule,
    AnalyticsSettingsModule,
    RadiusAuthenticationModule,
    LdapAuthenticationModule,
    AzureAuthenticationModule,
    TrustedCertificatesModule,
    ConfiguratorCredentialsModule,
    CredentialsModule,
    OperatorsSettingsModule,
    SecurityPoliciesModule,
    ConfiguratorCertificateModule
  ]
})
export class AdministrationModule {
}
